import PaperBase from '../../../../Paper/PaperBase';
import {
  AddWorkedExampleGranularStepButton,
  DeleteWorkedExampleGranularStepButton,
  UpdateWorkedExampleGranularStepButton
} from './Buttons';
import GranularStepCard from '../../../../card/GranularStepCard';
import IconTooltipButton from '../../../../button/IconTooltipButton';

const CardLevel = ({ lcs = [], levelId, level, onWorkedExamples, type, drId }) => {
  return (
    <div className='flex flex-nowrap w-full gap-1'>
      <PaperBase
        backgroundColor={level?.secondaryColor}
        color={level?.primaryColor}
        className='font-bold min-w-120px max-w-120px sticky left-0 z-10'
        children={level.name}
      />
      {lcs?.map((lc) => {
        const find = lc.granularSteps?.find((step) => step.levelId === levelId && step.isLevel);

        return (
          <GranularStepCard
            key={`levels-${levelId}-lc-${lc._id}`}
            backgroundColor={find ? level?.primaryColor : null}
            color={find ? level?.secondaryColor : null}
            step={{ ...find }}
            actions={
              find?.definition && (
                <AddWorkedExampleGranularStepButton
                  type={type}
                  onClick={() =>
                    onWorkedExamples(
                      {
                        drId,
                        lcId: lc._id,
                        gsId: find?.id
                      },
                      'create'
                    )
                  }
                />
              )
            }
            actionsWorkedExamples={(data) => (
              <div className='flex gap-1'>
                {data.fromLC ? (
                  <IconTooltipButton
                    title='Preview worked example'
                    icon='expand-alt'
                    onClick={(e) => {
                      e.stopPropagation();
                      onWorkedExamples(
                        {
                          drId,
                          lcId: lc._id,
                          gsId: find?.id,
                          ...data
                        },
                        'preview',
                        'worked-examples'
                      );
                    }}
                    style={{
                      width: 22,
                      height: 22,
                      color: 'currentColor',
                    }}
                  />
                ) : (
                  <>
                    <UpdateWorkedExampleGranularStepButton
                      type={type}
                      onClick={() =>
                        onWorkedExamples(
                          {
                            drId,
                            lcId: lc._id,
                            gsId: find?.id,
                            ...data
                          },
                          'edit'
                        )
                      }
                    />
                    <DeleteWorkedExampleGranularStepButton
                      type={type}
                      onClick={() =>
                        onWorkedExamples(
                          {
                            drId,
                            lcId: lc._id,
                            gsId: find?.id,
                            ...data
                          },
                          'delete'
                        )
                      }
                    />
                  </>
                )}
              </div>
            )}
            actionsTeachingSuggestions={(data) => (
              <>
                <IconTooltipButton
                  title='Preview teaching suggestion'
                  icon='expand-alt'
                  onClick={(e) => {
                    e.stopPropagation();
                    onWorkedExamples(
                      {
                        drId,
                        levelId,
                        levelName: level.name,
                        lcId: lc._id,
                        gsId: find?.id,
                        ...data
                      },
                      'preview',
                      'teaching-suggestions'
                    );
                  }}
                  style={{
                    width: 22,
                    height: 22,
                    color: 'currentColor',
                  }}
                />
              </>
            )}
          />
        );
      })}
    </div>
  );
};

export default CardLevel;
